import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Trash2, Loader2, ShieldAlert } from 'lucide-react';

export const ConfirmarSenhaExclusao = ({ aberto, protocolo, onConfirmar, onCancelar, excluindo }) => {
  const [senha, setSenha] = useState('');

  useEffect(() => {
    if (aberto) setSenha('');
  }, [aberto]);

  const confirmar = () => {
    if (!senha.trim() || excluindo) return;
    onConfirmar(senha);
  };

  return (
    <Dialog open={aberto} onOpenChange={(v) => { if (!v && !excluindo) onCancelar(); }}>
      <DialogContent className="sm:max-w-md" data-testid="modal-confirmar-exclusao">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-red-500">
            <ShieldAlert className="h-5 w-5" />
            Excluir venda {protocolo}
          </DialogTitle>
          <DialogDescription>
            Esta ação não pode ser desfeita. Digite <strong>sua senha de administrador</strong> para confirmar a exclusão.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          <Label htmlFor="senha-exclusao">Senha</Label>
          <Input
            id="senha-exclusao"
            type="password"
            autoFocus
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') confirmar(); }}
            placeholder="Digite sua senha"
            data-testid="input-senha-exclusao"
          />
        </div>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={onCancelar} disabled={excluindo} data-testid="btn-cancelar-exclusao">
            Cancelar
          </Button>
          <Button
            onClick={confirmar}
            disabled={!senha.trim() || excluindo}
            className="bg-red-600 hover:bg-red-700 text-white"
            data-testid="btn-confirmar-exclusao"
          >
            {excluindo ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Trash2 className="mr-2 h-4 w-4" />}
            {excluindo ? 'Excluindo...' : 'Excluir definitivamente'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmarSenhaExclusao;
